import { useEffect, useState } from "react";
import { Loader2, Phone, Users } from "lucide-react";
import { useEmployeeApi } from "../employeeApi";
import { initials } from "../prefs";

export default function TeamScreen() {
    const api = useEmployeeApi();
    const [team, setTeam] = useState(null);
    const [error, setError] = useState(false);
    const load = () => {
        setError(false);
        api.getTeam().then((d) => setTeam(d.team || [])).catch(() => setError(true));
    };
    useEffect(() => { load(); }, [api]); // eslint-disable-line react-hooks/exhaustive-deps
    if (error) return <div role="alert" data-testid="team-error" className="space-y-3 text-sm text-red-700">Kunne ikke hente teamet.<button onClick={load} data-testid="team-retry" className="block text-blue-600">Prøv igen</button></div>;
    if (!team) return <div className="flex justify-center py-20" data-testid="team-loading"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;
    return (
        <div className="space-y-4" data-testid="employee-team">
            <h1 className="text-2xl font-bold text-slate-900" data-testid="team-title">Team</h1>
            <p className="text-slate-500 text-sm" data-testid="team-count">{team.length} medarbejdere i virksomheden</p>
            {!team.length && <p className="py-12 text-center text-sm text-slate-500" data-testid="team-empty"><Users className="w-8 h-8 mx-auto mb-3" />Ingen medarbejdere registreret.</p>}
            <ul className="space-y-3" data-testid="team-list">
                {team.map((member) => (
                    <li key={member.id} data-testid={`team-${member.id}`} className="bg-white rounded-2xl border border-slate-200 p-4 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center font-bold text-slate-600 shrink-0">{initials(member.name)}</div>
                        <div className="flex-1 min-w-0">
                            <p className="font-semibold text-slate-900 break-words" data-testid={`team-name-${member.id}`}>{member.name}{member.is_me && " (dig)"}</p>
                            <p className="text-sm text-slate-500 break-words" data-testid={`team-role-${member.id}`}>{member.trade || member.role}</p>
                        </div>
                        {member.phone && <a href={`tel:${member.phone}`} aria-label={`Ring til ${member.name}`} title={`Ring til ${member.name}`} data-testid={`team-call-${member.id}`} className="p-2 rounded-lg text-blue-600 hover:bg-blue-50 transition-colors"><Phone className="w-5 h-5" /></a>}
                    </li>
                ))}
            </ul>
        </div>
    );
}